import React from "react";
import MediaTextSection from "./MediaTextSection";
import trajetoryImage from "../assets/chatgpt-image-31-de-jul.-de-2026-10_55_10-rrlrjKBRog2kOIeQ.avif"

// TODO: substitua pelo caminho/import real da imagem
// Ex.: import trajectoryImage from "../assets/trajetoria.jpg";
const TRAJECTORY_IMAGE_SRC = "";

export default function Trajectory() {
  return (
    <MediaTextSection
      eyebrow="Nossa Trajetória"
      title="Rigor técnico e suporte consultivo"
      paragraphs={[
        "A Eniato Contabilidade foi constituída para oferecer ao mercado corporativo uma assessoria técnica rigorosa e personalizada, substituindo a contabilidade tradicional por uma visão consultiva de negócios.",
        "Nossa equipe multidisciplinar atua junto à diretoria financeira para eliminar riscos regulatórios, assegurando previsibilidade operacional e suporte analítico contínuo para decisões de alto impacto.",
      ]}
      button={{ label: "Conhecer Soluções", to: "/servicos" }}
      imageSrc={trajetoryImage}
      imageAlt="Edifício corporativo à noite"
      reverse
    />
  );
}
